export default [
  { id: 0, name: 'Ready for Billing' },
  { id: 1, name: 'Invoices' },
];
